import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import { useEffect } from "react";
import Quill from "quill";

const Parchment = Quill.import("parchment");
const ListColor = new Parchment.Attributor.Style("list-color", "color", {
  scope: Parchment.Scope.BLOCK,
});
Quill.register(ListColor, true);

function ViewQuillComponent({ content, type }) {
  const { quill, quillRef } = useQuill({
    readOnly: true,
    modules: {
      toolbar: false,
    },
  });

  useEffect(() => {
    if (quill && content) {
      quill.setContents([]);

      if (type === "json") {
        const data =
          typeof content === "string" ? JSON.parse(content) : content;
        quill.setContents(data);
      } else {
        quill.setText(content);
      }

      setTimeout(() => {
        const lines = quill.getLines(0, quill.getLength());

        lines.forEach((line) => {
          if (line.domNode.tagName === "LI") {
            const savedColor = line.formats()["list-color"];

            if (savedColor) {
              line.domNode.style.color = savedColor;
            } else {
              const coloredChild =
                line.domNode.querySelector('[style*="color"]');
              if (coloredChild && coloredChild.style.color) {
                line.domNode.style.color = coloredChild.style.color;
              }
            }
          }
        });
      }, 50);
    }
  }, [quill, content, type]);

  return (
    <div className="view-editor">
      <div ref={quillRef}></div>
    </div>
  );
}

export default ViewQuillComponent;
